import React, { useState, useEffect } from 'react';
import { Container } from '../ui/Container';
import { useIsMobile } from '../../Hooks/useIsMobile';
import { getImagePath } from '../../Utils/Utilities';


const VisitSection = () => {
  const [currentImageIndex, setCurrentImageIndex] = useState(0);
  const isMobile = useIsMobile();

  const images = [
    getImagePath('/Images/BiziPeach1.png'),
    getImagePath('/Images/BiziModi1.png'),
    getImagePath('/Images/BiziPeacock1.png'),
    getImagePath('/Images/BiziTeam1.png')
  ];
  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentImageIndex((prev) => (prev + 1) % images.length);
    }, 3000);

    return () => clearInterval(interval);
  }, [images.length]);

  if (!isMobile) return null;

  return (
    <section className="bg-background-light py-12 md:py-16 lg:py-20 border-top ">
      {/* Visit Us Section */}
      <div id="visitUs" className="px-4 text-center">
        <Container>
          <h2 className="text-[30px] md:text-[40px] font-bold secttl mb-8">
            Visit Us!
          </h2>
          <div className="mt-5 overflow-hidden rounded shadow-light max-w-2xl mx-auto">
            <iframe
              src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3666.0056545811954!2d72.6274358!3d23.2428813!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x395c2b81b4daa24b%3A0x8706248f9c2742fc!2sBiziverse%20Pvt.%20Ltd.!5e0!3m2!1sen!2sin!4v1724222177105!5m2!1sen!2sin"
              width="100%"
              height={isMobile ? "300" : "400"}
              style={{ border: 0 }}
              allowFullScreen=""
              loading="lazy"
              referrerPolicy="no-referrer-when-downgrade"
              title="Biziverse Office Location"
            />
          </div>
        </Container>
      </div>
    </section>
  );
};

export default VisitSection;